import React from 'react'
import { useState } from 'react';

import { NEW_URL } from '../../../../constants/applicationConstants';
import { AdsCard } from '../../../common/adsCard/adsCard.jsx';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Pagination } from '../../../common/pagination/uiPagination.js';

const SuggestedOfferJsx = (props) => {

  const {

    addData,onPaginationButtonClick, page
  } = props;

  const itemsPerPage = 10

  const [currentPage] = useState(1);

  const currentItems = addData?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

 

  return (
    <>
      <section className="alldashboard cust-adds">

        <div className="dashboardrightpanel ">
          <div className="suggestedoffercustomer">
            <div className="dashboard-ps-offer">
            <section className="limitedoffer ">
                <div className="limitedofferinner">
                  <div className="offerslider offerslidercustadd">
                       {currentItems?.map((offer, index) => (
                        <div key={index}>
                            <div class={`sliouter ${offer?.parentInstitutionCategory}`}> 
                            <AdsCard
                      imageUrl={`${NEW_URL}/${offer.imageUrl}`}
                      description={offer.description}
                      category={offer?.subInstitutionCategory?.name}
                      externalLink={offer.externalLink}
                      categoryname={offer.institutionCategoryId}
                    /> </div>
                          </div>
                        ))}
                         <section className="newpagination"> <Pagination
                        currentPage={currentPage}
                        page={page}
                        allOffersData={addData}
                        currentItems={currentItems}
                        onPaginationButtonClick={onPaginationButtonClick}
                        itemsPerPage={itemsPerPage}
                      /></section>
                  </div>
                </div>                      
            </section>
          </div>
          </div>
        </div>
      </section>
    </>

  );
};

export default SuggestedOfferJsx;